module.exports = "<div class=\"<%= gw_multiselect_container %>\">\r\n    <gw-multi-select-row ng-repeat=\"selectItem in $ctrl.selectItems track by $index\"\r\n                         model=\"selectItem.model\"\r\n                         icon=\"selectItem.icon\"\r\n                         select-text=\"selectItem.selectText\"\r\n                         help-text=\"selectItem.helpText\"\r\n                         id=\"$index\">\r\n    </gw-multi-select-row>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/multiselect/components/multiselect/multiselect.html
// module id = 589
// module chunks = 0